// Hub + Search + Tags API-helpers.

import { api } from './client';
import type {
  HubResponse,
  SearchResponse,
  TagsResponse,
} from './setsTypes';

interface DataEnvelope<T> {
  data: T;
}

// ─── Hub ─────────────────────────────────────────────────────────────

export async function getHub(workspaceId?: string): Promise<HubResponse> {
  const res = await api.get<DataEnvelope<HubResponse>>(`/hub`, {
    query: workspaceId ? { workspace: workspaceId } : undefined,
  });
  return res.data;
}

// ─── Search ──────────────────────────────────────────────────────────

export async function search(
  query: string,
  workspaceId?: string,
): Promise<SearchResponse> {
  const q = query.trim();
  if (!q) {
    return { query: '', total: 0, results: [], images: [] };
  }
  const res = await api.get<DataEnvelope<SearchResponse>>(`/search`, {
    query: {
      q,
      workspace: workspaceId,
    },
  });
  return res.data;
}

// ─── Tags (workspace-scoped) ─────────────────────────────────────────

export async function getTags(workspaceId: string): Promise<TagsResponse> {
  const res = await api.get<DataEnvelope<TagsResponse>>(
    `/workspaces/${workspaceId}/tags`,
  );
  return res.data;
}
